<template>
  <ComboboxTree
    v-if="!isLoading"
    :triggerLabel="name"
    :name="name"
    :buildings="buildings"
    :showSearch="true"
    :showClear="true"
    :open="open"
    :handle="handle"
    type="asset"
    @update:open="emit('update:open', $event)"
  />
</template>

<script setup>
// Libraries
import { computed, ref } from "vue";

// Components
import { ComboboxTree } from "@/SharedComponents/Filters/ComboboxTree";

// Composables
import { useSites } from "@/Composables/useSites";

// Emits
const emit = defineEmits(["update:open"]);

// Props
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  tenant: {
    type: Array,
    required: true,
  },
  open: {
    type: Boolean,
    default: false,
  },
});

// Refs
const tenant = ref(props.tenant ?? []);
const handle = ref("assets");

// Buildings
const { isLoading, data } = useSites();

// Computed props
const buildings = computed(() => {
  if (isLoading.value) {
    return [
      {
        options: [],
      },
    ];
  }

  return tenant.value.length === 1
    ? data.value.filter((building) => building.id === tenant.value[0])
    : data.value;
});
</script>
